import { createSelector } from "reselect";
import moment from "moment";

const getRooms = state => state.rooms.data;
const getCleaningList = state => state.cleaning.data;
const getKeyword = state => state.scheduleCleaning.roomPicker.availableKeyword;
const getSelectedKeyword = state =>
  state.scheduleCleaning.roomPicker.selectedKeyword;
const getDateRanges = state => state.scheduleCleaning.dateRangePicker;
const getSelectedRooms = state => state.scheduleCleaning.roomPicker.selected;
const getSelectedCleaning = state => state.scheduleCleaning.selectedCleaning;

const getCleaningRoomsForDateRange = createSelector(
  [getCleaningList, getDateRanges, getSelectedCleaning],
  (cleaninglist, dateRanges, cleaningId) =>
    cleaninglist
      .filter(
        cleaning =>
          cleaning._id !== cleaningId &&
          moment.utc(cleaning.from) <= dateRanges.dateTo &&
          moment.utc(cleaning.to) >= dateRanges.dateFrom
      )
      .reduce((roomIds, cleaning) => roomIds.concat(cleaning.rooms), [])
);

export const getAvailableRooms = createSelector(
  [getRooms, getCleaningRoomsForDateRange, getSelectedRooms],
  (rooms, roomIds, selectedRooms) =>
    rooms.filter(
      room =>
        !roomIds.find(r => r.roomId === room.roomId) &&
        !selectedRooms.find(r => r.roomId === room.roomId)
    )
);

export const getAvailableRoomsWithScheduledRooms = createSelector(
  [getRooms, getSelectedRooms],
  (rooms, selectedRooms) =>
    rooms.filter(room => !selectedRooms.find(r => r.roomId === room.roomId))
);

export const filterAvailableRoomsWithScheduledRoomsByKeyword = createSelector(
  [getAvailableRoomsWithScheduledRooms, getKeyword],
  (rooms, keyword) => {
    const filtered = rooms.filter(
      room => keyword === "" || room.name.includes(keyword)
    );

    return [...filtered];
  }
);

export const filterAvailableRoomsByKeyword = createSelector(
  [getAvailableRooms, getKeyword],
  (rooms, keyword) => {
    const filtered = rooms.filter(
      room => keyword === "" || room.name.includes(keyword)
    );

    return [...filtered];
  }
);

export const filterSelectedRoomsByKeyword = createSelector(
  [getSelectedRooms, getSelectedKeyword],
  (rooms, keyword) =>
    rooms.filter(room => keyword === "" || room.name.includes(keyword))
);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/selectors.js